interface RadioOptions {
  label: string
  value: string
}

export function redcapChoicesToRadioOptions(
  choices: string
): Array<RadioOptions> {
  const options = choices.split("|")

  return options.map((str: string) => {
    const firstCommaIndex = str.indexOf(",")
    const value = str.substring(0, firstCommaIndex).replace(/\s/g, "")
    const label = str.substring(firstCommaIndex + 1).replace(/^\s+|\s+$/g, "")
    return { label: label, value: value }
  })
}
